export default {
	"um.new.user": "New User",
	"um.user.name": "User Name",
	"um.phone.number": "Phone Number",
	"um.email": "Email",
	"um.admin": "Admin",
	"um.normal": "Normal",
	"um.password": "Password",
	"um.confirmPassword": "Confirm Password",
	"um.role": "Role",
	"um.modify.user": "Modify User",
	"um.add.user.success": "Add user successfully",
	"um.edit.user.success": "Modify user successfully",
	"um.digut.number": "569 + 8 digit number",
	"um.delete.user.success": "Delete user successfully",
	"um.delete.user.sure": "Are you sure to delete this user?",
	"um.total": "Total",
	"um.items": "items",
	"um.select": "Select",
	"um.acct": "Account",
	"um.unblock.user.sure": "Are you sure to unblock this user?",
	"um.block.user.sure": "Are you sure to block this user?",
	"um.unblock.user.success": "Unblock user successfully",
	"um.block.user.success": "Block user successfully",
	"um.block": "Block",
	"um.unblock": "Unblock",
	"um.user.name.rule": "Only 6 to 100 numeric letters and characters @ _-. Combination",
	"um.customer.admin": "Customer Admin",
	"um.department.admin": "Department Admin",
	"um.user": "User",
	"um.user.id": "User ID",
	"um.confirm.password": "confirm Password",
	"um.department": "Department",
	"um.super.admin": "Super Admin",
	"um.bcare.admin": "Bcare Admin"
}